import React from "react";
import "../../styles/howItWorks.scss";
import { useNavigate } from "react-router-dom";
import backIcon from "../../img/Back.svg";
import { useTheme } from "../../ThemeContext.js";
import translations from "../../translate.js";

const HowItWorksPage = () => {
  const language = localStorage.getItem("language") || "lv";
  const text = translations[language];
  const { theme } = useTheme();
  const navigate = useNavigate();

  // Dynamically set image path based on the selected language
  const filterExampleImage = require(`../../img/${language}/filterExample.png`);

  return (
    <div className="how-it-works-container" data-theme={theme}>
      {/* Back Button and Title */}
      <div className="title-container">
        <img
          src={backIcon}
          alt="Back"
          className="back-icon"
          onClick={() => navigate("/main")}
        />
        <h2 className="title">{text.howWorks}</h2>
      </div>

      <div className="divider"></div>

      {/* Page Content */}
      <div className="content">
        <h1>{text.howitworks}</h1>
        <div className="description">
          <p>{text.howitworksExplanation1}</p>
          <div className="line-break"></div>
          <p>{text.howitworksExplanation2}</p>
        </div>

        <h2>{text.filterExample}</h2>
        <div className="description">
          <p>{text.filterExampleDescription}</p>

          {/* Image Example */}
          <div className="example-image-container">
            <img
              src={filterExampleImage}
              alt={`Filter Example ${language}`}
              className="example-image"
            />
          </div>
        </div>
      </div>

      <div className="divider"></div>

      {/* Navigate to Filters Page Button */}
      <div className="button-container">
        <button
          className="navigate-button"
          onClick={() => navigate("/filters")}
        >
          {text.goToFilters}
        </button>
      </div>
    </div>
  );
};

export default HowItWorksPage;
